import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import HomeService from "../../../Services/HomeService";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import jsPDF from "jspdf";
// import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

const ManageApartment = () => {
  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");
  const [designations, setDesignations] = useState([]);
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editID, setEditID] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({ city: "", name: "" });
  const [filterText, setFilterText] = useState("");
  const [filteredInformation, setFilteredInformation] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [allLocalities, setAllLocalities] = useState([]);
  const [cityIdForFilter, setCityIdforFilter] = useState("");
  const [localityIdForFilter, setLocalityIdForFilter] = useState("");
  const [filterLoading, setFilterLoading] = useState(false);

  const columns = [
    { name: "S.No.", selector: (row) => row.sln, sortable: true },
    { name: "City", selector: (row) => row.city, sortable: true, wrap: true },
    { name: "Locality", selector: (row) => row.locality, wrap: true },
    {
      name: "Apartment",
      selector: (row) => row.name,
      wrap: true,
    },
    {
      name: "Number of Properties",
      selector: (row) => row.numberOfProperties,
      wrap: true,
      center: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <>
          <span title="Edit" onClick={() => handleEdit(row)}>
            <i
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
          <span title="Delete" onClick={() => handleDelete(row.id)}>
            <i
              className="fa-solid fa-trash-can text-danger"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "#477DA5",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
        </>
      ),
    },
  ];

  // Fetch cities
  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      console.log("cities", res);
      if (res?.data) {
        setAllCities(res?.data);
        if (userCity) {
          setCities([res.data.find((item) => item._id === userCity)]);
        } else {
          console.log("LKO74", res.data);
          setCities(res.data);
        }
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  //Fetch Localities
  const fetchAllLocalities = async (cityId) => {
    try {
      const res = await HomeService.getLocalities();
      console.log("Localities", res);

      if (res?.data) {
        // setLocalities(res.data.filter((item) => item?.city?._id === cityId));
        setAllLocalities(res?.data);
      }
    } catch (error) {
      console.error("Error fetching localities:", error);
    }
  };

  const fetchAllData = async () => {
    setLoading(true);
    try {
      const res = await HomeService.getApartment();
      console.log("POI78", res?.data);

      const arr = res?.data?.map((ele, ind) => ({
        sln: ind + 1,
        city: ele?.city?.name,
        cityId: ele?.city?._id,
        locality: ele?.locality?.name,
        localityId: ele?.locality?._id,
        name: ele.aptName,
        numberOfProperties: ele?.noOfProperties,
        id: ele._id,
      }));
      setDesignations(arr);
      if (userCity) {
        setDesignations(arr.filter((item) => item.cityId === userCity));
      }
    } catch (error) {
      console.error("Error fetching locality:", error);
      toast.error("Failed to load locality!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  const handleEdit = (row) => {
    setIsEdit(true);
    fetchLocalities(row.cityId);
    setEditData({
      city: row.cityId,
      locality: row.localityId,
      aptName: row.name,
    });
    setEditID(row.id);
  };

  console.log("HTR103", editData);

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete Apartment?",
      text: "Are you sure you want to delete this apartment?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        const res = await HomeService.deleteApartment(id);
        if (res?.status) {
          Swal.fire("Deleted!", "Apartment has been deleted.", "success");
          fetchAllData();
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to delete apartment.", "error");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = {
        city: editData.city,
        locality: editData.locality,
        aptName: editData.aptName,
      };
      if (isEdit) {
        const res = await HomeService.updateApartment(editID, data);
        if (res?.status) {
          toast.success("Apartment updated successfully!");
          setIsEdit(false);
          setEditData({ city: "", locality: "", aptName: "" });
          fetchAllData();
        }
      }
    } catch (error) {
      toast.error("Failed to save locality.");
      console.error("Error saving locality:", error);
    }
  };

  const [localities, setLocalities] = useState([]);
  // Fetch localities
  const fetchLocalities = async (cityId) => {
    try {
      const res = await HomeService.getLocalities();
      console.log("HYT71", res);

      if (res?.data) {
        setLocalities(res.data.filter((item) => item?.city?._id === cityId));
      }
    } catch (error) {
      console.error("Error fetching localities:", error);
    }
  };

  useEffect(() => {
    fetchCities();
    fetchAllLocalities();
  }, []);

  const filter = () => {
    console.log(designations);
    const filteredData = designations.filter((item) => {
      return (
        item?.city?.toLowerCase().includes(filterText.toLowerCase()) ||
        item?.locality?.toLowerCase().includes(filterText.toLowerCase()) ||
        item?.name?.toLowerCase().includes(filterText.toLowerCase())
      );
    });

    console.log(filteredData);
    setFilteredInformation([...filteredData]);
  };

  useEffect(() => {
    filter();
  }, [filterText]);

  const handleFilter = async () => {
    if (!cityIdForFilter || !localityIdForFilter) {
      toast?.error("Please Fill all the fields");
      return;
    }

    try {
      const data = {
        city: cityIdForFilter,
        locality: localityIdForFilter,
      };

      const res = await HomeService.filterApartment(data);
      console.log("filter", res);
      if (res?.status) {
        const arr = res?.data?.map((ele, ind) => ({
          sln: ind + 1,
          city: ele?.city?.name,
          cityId: ele?.city?._id,
          locality: ele?.locality?.name,
          localityId: ele?.locality?._id,
          name: ele.aptName,
          numberOfProperties: ele?.noOfProperties,
          id: ele._id,
        }));
        setDesignations(arr);
      }
    } catch (error) {
      toast.error("Failed to filter Apartment.");
      console.error("Error Filtering Apartment:", error);
    }
  };

  //PDF and Excel Download

  // PDF Export Function
  const handleDownloadPDF = () => {
    const doc = new jsPDF();

    const tableColumn = [
      "S.No",
      "City",
      "Locality",
      "Apartment",
      "No. of Properties",
    ];
    const tableRows = [];

    const exportData = filterText ? filteredInformation : designations;

    exportData.forEach((item, index) => {
      tableRows.push([
        index + 1,
        item.city,
        item.locality,
        item.name,
        item.numberOfProperties,
      ]);
    });

    doc.text("Apartment List", 14, 15);

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 20,
    });

    doc.save("apartments.pdf");
  };

  // Excel Export Function
  const handleDownloadExcel = () => {
    const exportData = filterText ? filteredInformation : designations;

    const worksheet = XLSX.utils.json_to_sheet(
      exportData.map((item, index) => ({
        "S.No": index + 1,
        City: item.city,
        Locality: item.locality,
        Apartment: item.name,
        "No. of Properties": item.numberOfProperties,
      }))
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Apartments");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "apartments.xlsx");
  };

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          <div className="mt-5">
            <div style={headLineStyle} className="page-headline">
              Manage Apartment
            </div>
            <div style={{ marginBottom: "15px" }}>
              <input
                onChange={(e) => {
                  setFilterText(e?.target?.value);
                }}
                value={filterText}
                placeholder="Type to Search"
                style={{
                  border: "1px solid grey",
                  height: "35px",
                  width: "25%",
                  borderRadius: "5px",
                  padding: "0 5px",
                }}
              />
              <select
                style={{
                  border: "1px solid grey",
                  height: "35px",
                  width: "20%",
                  borderRadius: "5px",
                  padding: "0 5px",
                  marginLeft: "10px",
                }}
                value={cityIdForFilter}
                onChange={(e) => {
                  setCityIdforFilter(e?.target?.value);
                }}
              >
                <option>--Select City--</option>
                {allCities?.length == 0 ? (
                  <option>No City Found</option>
                ) : (
                  allCities?.map((e, i) => {
                    return <option value={e?._id}>{e?.name}</option>;
                  })
                )}
              </select>
              <select
                disabled={!cityIdForFilter}
                style={{
                  border: "1px solid grey",
                  height: "35px",
                  width: "20%",
                  borderRadius: "5px",
                  padding: "0 5px",
                  marginLeft: "10px",
                }}
                value={localityIdForFilter}
                onChange={(e) => {
                  setLocalityIdForFilter(e?.target?.value);
                }}
              >
                <option>--Select Locality--</option>
                {allLocalities?.filter(
                  (loc) => loc?.city?._id === cityIdForFilter
                ).length == 0 ? (
                  <option>No Locality Found</option>
                ) : (
                  allLocalities
                    ?.filter((loc) => loc?.city?._id === cityIdForFilter)
                    ?.map((loc, i) => (
                      <option key={i} value={loc?._id}>
                        {loc?.name}
                      </option>
                    ))
                )}
              </select>
              <button
                style={{
                  padding: "5px 10px",
                  borderRadius: "5px",
                  backgroundColor: "#73fc03",
                  fontWeight: "600",
                  border: "none",
                  marginLeft: "10px",
                }}
                onClick={() => {
                  handleFilter();
                }}
              >
                Filter
              </button>
              <button
                style={{
                  padding: "5px 10px",
                  borderRadius: "5px",
                  backgroundColor: "#73fc03",
                  fontWeight: "600",
                  border: "none",
                  marginLeft: "10px",
                }}
                onClick={() => {
                  handleDownloadPDF();
                }}
              >
                {/* {`Download PDF(${
                  filteredInformation?.length || designations?.length
                })`} */}
                Download PDF ({designations?.length})
              </button>
              <button
                style={{
                  marginTop: "5px",
                  padding: "5px 10px",
                  borderRadius: "5px",
                  backgroundColor: "#73fc03",
                  fontWeight: "600",
                  border: "none",
                  marginLeft: "10px",
                }}
                onClick={() => {
                  handleDownloadExcel();
                }}
              >
                {/* {`Download Excel(${
                  filteredInformation?.length || designations?.length
                })`} */}
                Download Excel ({designations?.length})
              </button>
            </div>
            {loading ? (
              <p>Loading...</p>
            ) : (
              <>
                {isEdit ? (
                  <section className="chartBox_area">
                    <h2>View/Modify Apartment Details</h2>
                    <hr />
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-md-3 mt-3">
                          <label>
                            City<span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="city"
                            value={editData.city}
                            onChange={(e) => {
                              setEditData({
                                ...editData,
                                city: e.target.value,
                              });
                              fetchLocalities(e.target.value);
                            }}
                            required
                          >
                            <option value="" disabled>
                              ---Select---
                            </option>
                            {cities.map((city) => (
                              <option key={city._id} value={city._id}>
                                {city.name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="col-md-3 mt-3">
                          <label>
                            Locality<span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control"
                            value={editData.locality}
                            onChange={(e) => {
                              setEditData({
                                ...editData,
                                locality: e.target.value,
                              });
                            }}
                            required
                          >
                            <option value="" disabled>
                              ---Select---
                            </option>
                            {localities.map((item, key) => (
                              <option key={key} value={item._id}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="col-md-6 mt-3">
                          <label htmlFor="name">
                            Apartment Name<span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name="aptName"
                            className="form-control"
                            value={editData.aptName}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                aptName: e.target.value,
                              })
                            }
                            placeholder="Enter apartment name"
                            required
                          />
                        </div>
                      </div>
                      <button type="submit" className="btn btn-primary mt-3">
                        Save Changes
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary mt-3"
                        style={{ marginLeft: "11px" }}
                        onClick={() => {
                          setEditID(null);
                          setIsEdit(false);
                        }}
                      >
                        Cancel
                      </button>
                    </form>
                  </section>
                ) : (
                  <section className="chartBox_area">
                    <DataTable
                      columns={columns}
                      //   data={designations}
                      data={filterText ? filteredInformation : designations}
                      pagination
                      responsive
                      highlightOnHover
                    />
                  </section>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageApartment;
